import React from "react";
import PropTypes from "prop-types";

const FormHelperText = (errorMsg) => (
  <div className="error">{errorMsg?.message}</div>
);

FormHelperText.propTypes = {
  message: PropTypes.string,
};

export default FormHelperText;
